import type { ModelCoverageDataKind } from "src/store/api/generatedApi";
import theme from "src/theme";

export type MissingDataKind = ModelCoverageDataKind | null;

export const MISSING_DATA_KINDS: readonly MissingDataKind[] = [
  null,
  "predictions",
  "embedded",
  "transformed",
  "video",
] as const;

export const missingDataKindKey = (kind: MissingDataKind): string => kind ?? "";

export const MISSING_DATA_KIND_COLORS: Record<string, string> = {
  "": theme.palette.success.main,
  predictions: theme.palette.warning.dark,
  embedded: theme.palette.info.main,
  transformed: theme.palette.info.light,
  video: theme.palette.grey[500],
};

export const MISSING_DATA_KIND_TRANSLATION_KEYS: Record<string, string> = {
  "": "pipelineLevelFullPipeline",
  predictions: "pipelineLevelMissingPredictions",
  embedded: "pipelineLevelMissingEmbeddings",
  transformed: "pipelineLevelMissingTransforms",
  video: "pipelineLevelMissingVideo",
};
